import { Layout, LayoutProps } from '@volkswagen-onehub/components-core';
import React from 'react';
import { isLayerForm } from '../../../helpers/form-helpers';

export function LayoutExtended(props: LayoutProps) {
	const { children, appearance } = props;

	// Eliminamos todos los breakpoints superiores a 960 si es un Layer
	const filteredAppearance =
		isLayerForm() && appearance
			? Object.fromEntries(Object.entries(appearance).filter(([key]) => Number(key) <= 960))
			: appearance;

	return (
		<Layout {...props} appearance={filteredAppearance}>
			{children}
		</Layout>
	);
}
